import { Button } from './ui/button';
import { ArrowRight, CheckCircle, Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader } from './ui/card';
import { useEffect } from 'react';

export function Hero() {

  useEffect(() => {
    // Load Zoho analytics script
    const script = document.createElement('script');
    script.id = 'wf_anal';
    script.src = 'https://crm.zohopublic.in/crm/WebFormAnalyticsServeServlet?rid=d7643ade7e087b51767c2061c5ab2e9316599efd5de35dfa87904ad9380280a35e131cf5af9765b3f3c07c001edb402egidb73a94a3211d51ed92a1aaab54ff3097ff555f762a313e18b967aeacf3199e94gidf12fbadf3a23fed677723e955443e00bf37a464868ed90063b62cacdcd6c8653gid10db358171d86b7beb07e9994a02697da06d5d2eb436e09922189348028fb64b&tw=7c439e87ec0767997dcf57f5013d2e616a62ad68de1950accfefd4ba543d4274';
    script.async = true;
    
    // Check if script already exists
    if (!document.getElementById('wf_anal')) {
      document.head.appendChild(script);
    }

    // Add the Zoho validation functions to window object
    (window as any).validateEmail961908000000514006 = () => {
      const form = document.forms['WebToLeads961908000000514006' as any] as HTMLFormElement;
      if (!form) return true;
      
      const emailFld = form.querySelectorAll('[ftype=email]') as NodeListOf<HTMLInputElement>;
      for (let i = 0; i < emailFld.length; i++) {
        const emailVal = emailFld[i].value;
        if ((emailVal.replace(/^\s+|\s+$/g, '')).length !== 0) {
          const atpos = emailVal.indexOf('@');
          const dotpos = emailVal.lastIndexOf('.');
          if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
            alert('Please enter a valid email address.');
            emailFld[i].focus();
            return false;
          }
        }
      }
      return true;
    };

    (window as any).checkMandatory961908000000514006 = () => {
      const mndFileds = ['Company', 'Last Name', 'Email'];
      const fldLangVal = ['Company', 'Last Name', 'Email'];
      
      const form = document.forms['WebToLeads961908000000514006' as any] as HTMLFormElement;
      if (!form) return false;
      
      for (let i = 0; i < mndFileds.length; i++) {
        const fieldObj = form[mndFileds[i] as any] as HTMLInputElement;
        if (fieldObj) {
          if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length === 0) {
            if (fieldObj.type === 'file') {
              alert('Please select a file to upload.');
              fieldObj.focus();
              return false;
            }
            alert(fldLangVal[i] + ' cannot be empty.');
            fieldObj.focus();
            return false;
          }
          else if (fieldObj.nodeName === 'SELECT') {
            const selectField = fieldObj as unknown as HTMLSelectElement;
            if (selectField.options[selectField.selectedIndex].value === '-None-') {
              alert(fldLangVal[i] + ' cannot be none.');
              fieldObj.focus();
              return false;
            }
          }
          else if (fieldObj.type === 'checkbox') {
            if (!fieldObj.checked) {
              alert('Please accept ' + fldLangVal[i]);
              fieldObj.focus();
              return false;
            }
          }
        }
      }
      
      if (!(window as any).validateEmail961908000000514006()) {
        return false;
      }
      
      return true;
    };

    // Set dynamic return URL based on current page
    const setDynamicReturnURL = () => {
      const returnURLField = document.querySelector('input[name="returnURL"]') as HTMLInputElement;
      if (returnURLField) {
        returnURLField.value = window.location.href;
      }
    };

    // Set return URL when component mounts
    setTimeout(setDynamicReturnURL, 100);

    return () => {
      // Cleanup function to remove script if component unmounts
      const existingScript = document.getElementById('wf_anal');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section id="home" className="pt-24 lg:pt-28 pb-16 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 overflow-hidden relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-20 h-20 bg-blue-600 rounded-full blur-xl"></div>
        <div className="absolute top-40 right-20 w-32 h-32 bg-purple-600 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-indigo-600 rounded-full blur-xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center min-h-[500px]">
          {/* Left Content */}
          <div className="lg:col-span-2 space-y-6 lg:space-y-8 order-1 lg:order-1">
            <div className="space-y-4 lg:space-y-6">
              <div className="inline-flex items-center">
                <img 
                  src="/assets/logos/zoho-partner-badge.png" 
                  alt="Zoho Partner Badge" 
                  style={{ height: 58, border: '1px solid #d1d5db', borderRadius: 8 }}
                />
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-tight">
                Transform Your Business with <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">Zoho and Automation</span>
              </h1>
              
              <p className="text-lg lg:text-xl xl:text-2xl text-gray-600 leading-relaxed max-w-3xl">
                Streamline operations, boost productivity, and accelerate growth with expert Zoho CRM, Zoho One, 
                Zoho Analytics, and automation implementation services from India's trusted technology partner.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://consult.optiwizer.com/#/book_consultation" target="_blank" rel="noopener noreferrer">
                <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white text-base lg:text-lg px-6 lg:px-8 py-3 lg:py-4 shadow-lg">
                  Start Your Transformation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </a>
              <a href="https://consult.optiwizer.com/#/book_consultation" target="_blank" rel="noopener noreferrer">
                <Button size="lg" variant="outline" className="text-base lg:text-lg px-6 lg:px-8 py-3 lg:py-4 border-2 hover:bg-gray-50">
                  <Calendar className="mr-2 h-5 w-5" />
                  Book Free Consultation
                </Button>
              </a>
            </div>

            <div className="grid grid-cols-3 gap-6 lg:gap-12 pt-6 lg:pt-8 max-w-2xl">
              <div className="text-center">
                <div className="text-2xl lg:text-4xl font-bold text-blue-600">500+</div>
                <div className="text-sm lg:text-base text-gray-600">Projects Delivered</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-4xl font-bold text-blue-600">98%</div>
                <div className="text-sm lg:text-base text-gray-600">Client Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-4xl font-bold text-blue-600">5+</div>
                <div className="text-sm lg:text-base text-gray-600">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Right Contact Form */}
          <div className="lg:col-span-1 relative order-2 lg:order-2">
            <Card className="bg-white/95 backdrop-blur-sm shadow-2xl border-0 relative z-10 max-w-sm mx-auto lg:max-w-none">
              <CardHeader className="text-center pb-2">
                <h2 className="text-base lg:text-lg font-bold text-gray-900" data-slot="card-title">
                  Get Your Free Consultation
                </h2>
                <p className="text-gray-600 text-xs">
                  Transform your business with Zoho. Start today!
                </p>
              </CardHeader>
              <CardContent className="p-3 lg:p-4 pt-0">
                {/* Compact Benefits List */}
                <div className="space-y-1 mb-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                    <span className="text-xs text-gray-700">Free assessment &amp; custom roadmap</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                    <span className="text-xs text-gray-700">ROI analysis &amp; implementation plan</span>
                  </div>
                </div>

                {/* Zoho CRM Form - Using native HTML form without React interference */}
                <div className="zoho-form-container">
                  <div id="crmWebToEntityForm" className="zcwf_lblLeft crmWebToEntityForm" style={{backgroundColor: 'white', color: 'black', maxWidth: '600px'}}>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />
                    
                    <form 
                      id="webform961908000000514006" 
                      action="https://crm.zoho.in/crm/WebToLeadForm" 
                      name="WebToLeads961908000000514006" 
                      method="POST" 
                      acceptCharset="UTF-8"
                      onSubmit={(e) => {
                        const isValid = (window as any).checkMandatory961908000000514006();
                        if (!isValid) {
                          e.preventDefault();
                          return false;
                        }
                        return true;
                      }}
                    >
                      
                      {/* Required Hidden Fields */}
                      <input type="text" style={{display:'none'}} name="xnQsjsdp" defaultValue="f1fdae68f7843ae404a1c9bdb17b3cf88fe7340b7bf4681581a76404f5cc98f2" readOnly />
                      <input type="hidden" name="zc_gad" id="zc_gad" defaultValue="" />
                      <input type="text" style={{display:'none'}} name="xmIwtLD" defaultValue="63416910ce071231250ab4789f8cc7f7c2a091d722bcad1bd410503b28140914982203cbcbc7deaa630726fb120d11cc" readOnly />
                      <input type="text" style={{display:'none'}} name="actionType" defaultValue="TGVhZHM=" readOnly />
                      <input type="text" style={{display:'none'}} name="returnURL" defaultValue="" readOnly />
                      
                      {/* Hidden Lead Source Field */}
                      <div style={{display: 'none'}}>
                        <select id="Lead_Source" name="Lead Source" defaultValue="Website">
                          <option value="-None-">-None-</option>
                          <option value="Advertisement">Advertisement</option>
                          <option value="Website">Website</option>
                          <option value="Cold Call">Cold Call</option>
                          <option value="Employee Referral">Employee Referral</option>
                          <option value="External Referral">External Referral</option>
                          <option value="Online Store">Online Store</option>
                          <option value="Partner">Partner</option>
                          <option value="Public Relations">Public Relations</option>
                          <option value="Sales Email Alias">Sales Email Alias</option>
                          <option value="Seminar Partner">Seminar Partner</option>
                          <option value="Internal Seminar">Internal Seminar</option>
                          <option value="Trade Show">Trade Show</option>
                          <option value="Web Download">Web Download</option>
                          <option value="Web Research">Web Research</option>
                          <option value="Chat">Chat</option>
                          <option value="X (Twitter)">X (Twitter)</option>
                          <option value="Facebook">Facebook</option>
                          <option value="Linkedin">Linkedin</option>
                        </select>
                      </div>
                      
                      <input type="text" style={{display: 'none'}} name="aG9uZXlwb3Q" defaultValue="" />

                      {/* Name Fields Row */}
                      <div className="zcwf_row">
                        <div className="flex gap-2">
                          {/* First Name */}
                          <div className="flex-1">
                            <div className="zcwf_col_lab">
                              <label htmlFor="First_Name" className="text-xs font-medium text-gray-700 mb-0.5 block">
                                First Name
                              </label>
                            </div>
                            <div className="zcwf_col_fld">
                              <input 
                                type="text" 
                                id="First_Name" 
                                name="First Name" 
                                maxLength={40}
                                className="form-input w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="First name"
                              />
                            </div>
                          </div>

                          {/* Last Name */}
                          <div className="flex-1">
                            <div className="zcwf_col_lab">
                              <label htmlFor="Last_Name" className="text-xs font-medium text-gray-700 mb-0.5 block">
                                Last Name <span className="text-red-500">*</span>
                              </label>
                            </div>
                            <div className="zcwf_col_fld">
                              <input 
                                type="text" 
                                id="Last_Name" 
                                name="Last Name" 
                                maxLength={80}
                                className="form-input w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Last name"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Company */}
                      <div className="zcwf_row">
                        <div className="zcwf_col_lab">
                          <label htmlFor="Company" className="text-xs font-medium text-gray-700 mb-0.5 block">
                            Company <span className="text-red-500">*</span>
                          </label>
                        </div>
                        <div className="zcwf_col_fld">
                          <input 
                            type="text" 
                            id="Company" 
                            name="Company" 
                            maxLength={200}
                            className="form-input w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Company name"
                            required
                          />
                        </div>
                      </div>

                      {/* Email */}
                      <div className="zcwf_row">
                        <div className="zcwf_col_lab">
                          <label htmlFor="Email" className="text-xs font-medium text-gray-700 mb-0.5 block">
                            Email <span className="text-red-500">*</span>
                          </label>
                        </div>
                        <div className="zcwf_col_fld">
                          <input 
                            type="text" 
                            id="Email" 
                            name="Email" 
                            maxLength={100}
                            className="form-input w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Business email"
                            required
                          />
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="zcwf_row">
                        <div className="zcwf_col_lab">
                          <label htmlFor="Mobile" className="text-xs font-medium text-gray-700 mb-0.5 block">
                            Mobile
                          </label>
                        </div>
                        <div className="zcwf_col_fld">
                          <input 
                            type="tel" 
                            id="Mobile" 
                            name="Mobile" 
                            maxLength={30}
                            className="form-input w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Phone number"
                          />
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="zcwf_row">
                        <div className="zcwf_col_fld">
                          <input 
                            type="submit" 
                            id="formsubmit" 
                            className="formsubmit zcwf_button w-full py-2.5 px-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm font-medium rounded-md hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-md hover:shadow-lg cursor-pointer"
                            value="Book Free Consultation"
                            name="submit"
                          />
                        </div>
                      </div>
                    </form>

                  </div>
                </div>

                {/* Compact Trust Indicators */}
                <div className="mt-3 pt-2 border-t border-gray-200">
                  <div className="flex items-center justify-center space-x-3 text-xs text-gray-500">
                    <div className="flex items-center space-x-1">
                      <CheckCircle className="h-3 w-3 text-green-500" />
                      <span>Secure</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <CheckCircle className="h-3 w-3 text-green-500" />
                      <span>No Spam</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <CheckCircle className="h-3 w-3 text-green-500" />
                      <span>Free Call</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Compact Floating Elements */}
            <div className="absolute -top-2 -left-2 lg:-top-3 lg:-left-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg shadow-lg p-2 lg:p-3 z-20">
              <div className="flex items-center space-x-1 lg:space-x-2">
                <Calendar className="w-3 h-3 lg:w-4 lg:h-4" />
                <span className="text-xs font-medium">Free</span>
              </div>
            </div>
            
            <div className="absolute bottom-0 right-0 translate-x-1/4 translate-y-3/4 bg-yellow-300 text-black rounded-lg shadow-md px-3 py-1.5 flex flex-col items-center z-20 min-w-[80px] max-w-[110px]">
              <span className="text-sm lg:text-base font-bold leading-tight tracking-wide">Priority</span>
              <span className="text-xs lg:text-xs font-semibold leading-tight">Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}